export const $config = {
  apiUrl: "https://ai-search.smarket.com.cn/b",
};
